export const environment = {
  production: false,
  apiUrl: 'https://back-end-production-e1e1.up.railway.app/api',
  stripe_api_key: "pk_test_51RM9bo4Fl551OK2AVH2s6lkvlE2zW0aXUnCrpvP5Zn1wX2JBgknp8vVT4MCgBiTymrh971YkdbxV7hzZKHiz1WMS00V27tySCX"
};
